import { render } from "./OrderProduct.vue?vue&type=template&id=0ab6e99a"
import script from "./OrderProduct.vue?vue&type=script&lang=js"
export * from "./OrderProduct.vue?vue&type=script&lang=js"

import "./OrderProduct.vue?vue&type=style&index=0&id=0ab6e99a&lang=scss"
script.render = render

export default script